const Customer = () => import("@/views/customer/Customer.vue");

const TYPE = "ADMIN";

export default{
    path: "customer",
    meta: { label: "Customer" },
    component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "",
              meta: {
                requiresAuth: true,
                type: TYPE,
              },
              component: Customer,
            },
        ],
}